module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-calendar.svg?h=def374fa03c402b15a083682cf9c7472";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-calendar.svg
// module id = 2042
// module chunks = 12 15